import { actionCopyDa } from "./actionCopy";
import { listCopyDa } from "./listCopy";

export const profileCopyDa = {
    title: "Profil",
    description: "Administrer din profil og dine indstillinger",
    contactDetails: "Kontaktoplysninger",
    name: listCopyDa.name,
    titleLabel: "Titel",
    selectPlaceholder: "Vælg",
    requiredField: "Påkrævet",
    firstNameRequired: "Fornavn er påkrævet",
    lastNameRequired: "Efternavn er påkrævet",
    firstName: "Fornavn",
    lastName: "Efternavn",
    noName: "Intet navn",
    dateOfBirth: listCopyDa.dateOfBirth,
    dateOfBirthFormatDescription: "Brug venligst formatet DD MM ÅÅÅÅ.",
    dobPlaceholderDay: "DD",
    dobPlaceholderMonth: "MM",
    dobPlaceholderYear: "ÅÅÅÅ",
    dobDayRequired: "Dag er påkrævet",
    dobMonthRequired: "Måned er påkrævet",
    dobYearRequired: "År er påkrævet",
    dobMaxDaysInMonth: "Der er højst 31 dage i en måned",
    dobMonthsInYear: "Der er kun 12 måneder i et år",
    dobYearTooEarly: "Det årstal ligger for langt tilbage",
    dobYearInFuture: "Det ligger i fremtiden!",
    noDateOfBirth: "Ingen fødselsdato",
    email: listCopyDa.email,
    noEmail: "Ingen e-mail",
    updateEmail: "Opdater e-mail",
    validEmailAddress: "Angiv en gyldig e-mailadresse",
    accountSignInEmailRequired: "Angiv den login-e-mailadresse, du vil ændre",
    newEmailDifferentFromSignIn: "Den nye e-mailadresse skal være anderledes end den login-e-mailadresse, du erstatter",
    newEmailDifferentFromCurrent: "Den nye e-mailadresse skal være anderledes end din nuværende e-mailadresse",
    differentEmailAddress: "Angiv en anden e-mailadresse",
    noSignInEmailToChange: "Ingen login-e-mailadresse at ændre",
    emailUpdatedSuccessfully: "E-mailadresse opdateret",
    emailUpdateFailed: "Kunne ikke opdatere e-mailadressen. Prøv igen.",
    emailSavedToProfile: "E-mailadressen er gemt i din profil",
    emailSaveToProfileFailed: "Kunne ikke gemme e-mailadressen i din profil. Prøv igen.",
    loading: actionCopyDa.loading,
    profileEmailIntro: (email: string) => `Profilens e-mailadresse er ${email}.`,
    profileEmailIntroSuffix: "Angiv den nye adresse nedenfor.",
    signInEmailDiffersHelp:
        "Hvis login-e-mailadressen adskiller sig fra profilens (f.eks. efter et synkroniseringsproblem), skal du bruge det valgfrie felt.",
    noProfileEmailReplaceDescription:
        "Ingen e-mailadresse på denne profil. Angiv den login-e-mailadresse, der skal erstattes, og derefter den nye e-mailadresse.",
    signInEmailOnlyIfDifferent: "Login-e-mail (kun hvis den adskiller sig fra profilen)",
    signInEmail: "Login-e-mail",
    leaveBlankIfSameAsProfile: "Lad stå blankt, hvis den er den samme som profilen",
    newEmail: "Ny e-mail",
    emailAddressToChangeTo: "E-mailadresse at skifte til",
    accountSignInEmailIntro: (email: string) =>
        `Din login-e-mailadresse er ${email}, men din profil viser den ikke endnu. Du kan gemme den i din profil nu.`,
    saveEmailToProfile: "Gem e-mail i profil",
    saveEmailFirstDescription:
        "Når dette er gemt, kan du ændre adressen fra denne dialog. For at skifte til en anden e-mailadresse med et bekræftelseslink først, skal du bruge",
    noProfileEmailAddDescription:
        "Din profil har endnu ingen e-mailadresse. Tilføj en nedenfor - f.eks. hvis du oprettede dig med dit telefonnummer.",
    profileEmailLink: "Profil - E-mail",
    noEmailOnAccountPhoneSignup:
        "Ingen e-mailadresse på denne konto endnu (f.eks. hvis du oprettede dig med din telefon)",
    currentEmail: "Nuværende e-mail",
    emailConfirmationSecurityDescription:
        "Vi sender dig et bekræftelseslink via e-mail. Af sikkerhedshensyn ændres intet, før du åbner det link.",
    emailConfirmationSent:
        "Bekræftelse sendt - tjek din nye indbakke for et link fra os. Din login-e-mail ændres ikke, før du bekræfter.",
    emailChangeStartFailed: "Kunne ikke starte e-mailskift. Prøv igen.",
    sending: actionCopyDa.sending,
    sendConfirmationEmail: "Send bekræftelses-e-mail",
    phone: "Telefon",
    noPhoneNumber: "Intet telefonnummer",
    notifications: "Notifikationer",
    notificationPreferences: "Notifikationsindstillinger",
    notificationPreferencesMissing: "Notifikationsindstillinger mangler",
    notificationPreferencesNotSpecified: "Notifikationsindstillinger ikke angivet",
    notificationPreferencesDescription: "Vælg, hvordan du ønsker at modtage notifikationer",
    notificationsEnabled: "Aktiveret",
    notificationsDisabled: "Deaktiveret",
    notificationsDisabledWarningPatient:
        "Vi anbefaler at aktivere e-mail- eller SMS-notifikationer for at modtage vigtige påmindelser om dagbogsindtastninger og beskeder.",
    notificationsDisabledWarningClinician:
        "Vi anbefaler at aktivere e-mail- eller SMS-notifikationer for at modtage ugentlige oversigter over dine patienters fremskridt.",
    notificationPreferencesSaved: "Notifikationsindstillinger gemt",
    notificationPreferencesSaveFailed: "Kunne ikke gemme indstillinger",
    appearance: "Udseende",
    darkMode: "Mørk tilstand",
    darkModeDescription: "Brug en mørk baggrund i appen.",
    switchToDarkMode: "Skift til mørk tilstand",
    switchToLightMode: "Skift til lys tilstand",
    language: "Sprog",
    languageDescription: "Vælg sprog til menuer, knapper og påmindelser.",
    chooseLanguage: "Vælg sprog",
    otherActions: "Andre handlinger",
    billingAndSubscription: "Fakturering og abonnement",
    hospitalDetails: "Hospitalsoplysninger",
    clinicianNumberLabel: "Klinikernummer",
    clinicianNumberDescription: "Dette er dit GMC- eller HCPC-nummer",
    noClinicianNumber: "Intet klinikernummer",
    myOrganisations: "Mine organisationer",
    myTeam: "Team",
    teamPageDescription: "Alle i dine organisationer. Inviter kolleger og vælg en standardkontaktperson.",
    secretaryDefaultHelpTitle: "Standardkontaktperson",
    secretaryDefaultHelp:
        "Din standardkontaktperson for en organisation udfyldes som kontakt, når du inviterer en patient. Den første sekretær, du tilføjer, bliver automatisk standard. Du kan ændre det i tabellen.",
    secretaryDefaultColumnHelp: "Bruges som kontaktperson, når du inviterer patienter til den organisation.",
    filterRole: "Rolle",
    filterOrganisation: "Organisation",
    filterAddedBy: "Tilføjet af",
    filterAllRoles: "Alle roller",
    filterAllOrganisations: "Alle organisationer",
    filterAllAddedBy: "Alle",
    filterInvitedByMe: "Inviteret af mig",
    filterNotInvitedByMe: "Ikke inviteret af mig",
    filterFavouritesOnly: "Kun favoritter",
    filters: actionCopyDa.filters,
    filterTeamAria: "Filtrer team",
    teamFilterTitle: "Filtre",
    teamFilterDescription: "Filtrer listen efter rolle, organisation og favoritter.",
    selectRoles: "Vælg roller",
    selectOrganisations: "Vælg organisationer",
    columnsButton: actionCopyDa.columns,
    columnName: listCopyDa.name,
    columnRole: listCopyDa.role,
    columnOrganisation: listCopyDa.organisation,
    columnAddedBy: "Tilføjet af",
    columnDefaultSecretary: "Standardkontaktperson",
    columnFavourite: "Favorit",
    invitedByYou: "Du inviterede",
    addUser: "Tilføj bruger",
    membersShown: (count) => `${count} ${count === 1 ? "medlem" : "medlemmer"}`,
    defaultForOrganisation: (organisationName) => `Standard for ${organisationName}`,
    setAsDefaultForOrganisation: (organisationName) => `Angiv som standard for ${organisationName}`,
    viewAll: "Se alle",
    teamLabel: "Team",
    staffCount: (count: number) => `${count} medarbejdere`,
    memberCount: (count) => `${count} ${count === 1 ? "medlem" : "medlemmer"}`,
    favouritesCount: (count: number) => `${count} favoritter`,
    moreTeamMembers: (count: number) => `+${count} flere teammedlemmer`,
    noTeamMembersYet: "Ingen teammedlemmer endnu",
    searchTeamPlaceholder: "Søg...",
    searchTeamAria: "Søg efter teammedlemmer",
    closeSearch: "Luk søgning",
    openSearch: "Åbn søgning",
    allStaff: "Alle medarbejdere",
    invitedTab: "Inviteret",
    favouritesTab: "Favoritter",
    noTeamMembersFound: "Ingen teammedlemmer fundet.",
    noFavouritesYet: "Ingen favoritter endnu.",
    noInvitesYet: "Du har endnu ikke inviteret nogen brugere.",
    inviteColleaguesToBuildTeam: "Inviter kolleger for at begynde at opbygge dit team",
    manageTeam: "Administrer team",
    secretaryOrganisationsLabel: "Sekretærorganisationer",
    secretaryDefaultBadge: "Standard",
    setAsDefaultSecretary: "Angiv som standard",
    clearDefaultSecretary: "Fjern standard",
    addAsMySecretary: "Tilføj som min sekretær",
    removeAsMySecretary: "Fjern",
    addSecretaryForOrganisation: "Tilføj sekretær",
    inviteNewSecretary: "Inviter ny sekretær",
    chooseExistingSecretary: "Vælg fra organisation",
    chooseExistingSecretaryTitle: "Vælg en sekretær",
    noOtherSecretariesInOrganisation: "Ingen andre sekretærer fundet i denne organisation.",
    inviteUser: "Inviter bruger",
    diaryUsageUsedLabel: "Forbrug",
    diaryUsageUnlimited: "Ubegrænsede dagbøger",
    diaryUsageAtCapHint:
        "Du har nået din dagbogsgrænse for denne periode. Opgrader din plan for at invitere flere patienter.",
    changePassword: "Skift adgangskode",
    logout: "Log ud",
    help: "Hjælp",
    menu: "Menu",
    close: actionCopyDa.close,
    contactSupportPrompt: "Forvirret eller har brug for hjælp?",
    contactSupport: "Kontakt support",
    incompleteTitle: "Profil ufuldstændig",
    incompleteMessage:
        "For at bruge Patient Watch skal du først udfylde din profil med alle felter, der er markeret som manglende nedenfor.",
    profileCompletionLabel: (progress) => `Profilfuldførelse ${progress}%`,
    addNextMissingField: "Fuldfør din profil",
    addMissingName: "Tilføj navn",
    addMissingDateOfBirth: "Tilføj fødselsdato",
    addMissingEmail: "Tilføj e-mail",
    addMissingPhone: "Tilføj telefonnummer",
    addMissingOrganisation: "Tilføj organisation",
    addMissingNotifications: "Tilføj notifikationsindstillinger",
    navProfileDescription: "Opdater de oplysninger, som Patient Watch kræver for at fungere.",
    navDiaryLabel: "Dagbog",
    navDiaryDescription: "Opret dagbøger til patienter, så de kan spore deres symptomer.",
    goToDiary: "Gå til dagbog",
    addDoneSeeProgress: "Tilføj det, der er gjort, og se fremskridt",
    goToDiaries: "Gå til dagbøger",
    seeResults: "Se resultater",
    seeDiaries: "Se dagbøger",
    onboarding: "Oprettelse",
    onboardingNameTitle: "Hvad hedder du?",
    onboardingNameDescription: "Sådan identificerer din behandler dig i Patient Watch.",
    onboardingDateOfBirthTitle: "Hvad er din fødselsdato?",
    onboardingDateOfBirthDescription: "Vi bruger den til sikkert at matche din sundhedsjournal.",
    onboardingEmailTitle: "Hvad er din e-mail?",
    onboardingEmailDescription: "Vi bruger den kun til din Patient Watch-konto og beskeder om din behandling.",
    onboardingPhoneTitle: "Hvad er dit telefonnummer?",
    onboardingPhoneDescription: "SMS-påmindelser hjælper dig med at udfylde formularer til rette tid.",
    onboardingNotificationsTitle: "Hvordan skal vi påminde dig?",
    beginOnboarding: "Begynd oprettelse",
    onboardingSignedOutDescription: "Klik venligst på Fortsæt for at tilføje dine oplysninger.",
    continue: actionCopyDa.continue,
    next: actionCopyDa.next,
    save: actionCopyDa.save,
    cancel: actionCopyDa.cancel,
    skip: actionCopyDa.skip,
    skipConfirmTitle: "Er du sikker på, at du vil springe over?",
    skipEmailDescription:
        "E-mail bruges til vigtige notifikationer. At springe dette trin over kan påvirke din evne til at modtage rettidige opdateringer.",
    skipSmsDescription:
        "SMS bruges til vigtige notifikationer. At springe dette trin over kan påvirke din evne til at modtage rettidige opdateringer.",
    saving: actionCopyDa.saving,
    creating: "Opretter...",
    organisation: listCopyDa.organisation,
    organisationMissing: "Organisation mangler",
    addOrganisation: "Tilføj organisation",
    joinOrganisation: "Tilmeld organisation",
    organisationMissingDescription: "Tilmeld venligst en organisation for at oprette dagbøger.",
    addOrganisationToContinue: "Tilføj venligst en organisation for at fortsætte",
    informationMissing: "Information mangler",
    role: listCopyDa.role,
    openMenu: "Åbn menu",
    showUsers: "Vis brugere",
    showQrCode: "Vis QR-kode",
    organisationCode: "Organisationskode",
    organisationCodeDescriptionPrefix:
        "For at tilmelde en organisation skal du bruge den kode, de har givet dig. Hvis du ikke har en,",
    requestCode: "anmod om en kode",
    cantFindOrganisation: "Kan du ikke finde din organisation?",
    addOrganisationYourself: "Tilføj den selv",
    newOrganisationName: "Organisationens navn",
    searchExistingOrganisation: "Søg efter en eksisterende organisation i stedet",
    addNewOrganisation: "Tilføj organisation",
    addNewOrganisationDescription: "Vi opretter den og tilføjer dig som kliniker. Du kan invitere kolleger bagefter.",
    delete: actionCopyDa.delete,
    deleting: actionCopyDa.deleting,
    rolePatient: "Patient",
    roleClinician: "Kliniker",
    roleSecretary: "Sekretær",
    roleAdmin: "Administrator",
    roleManager: "Leder",
    roleValidator: "Validator",
    organisationDescription: "Dette er navnet på din klinik, praksis eller dit hospital.",
    profileOrganisationDescription: "Tilføjelse af en organisation muliggør datadeling mellem dig og organisationen.",
    yourOrganisation: "Din organisation",
    professional: "Faglig",
    medicalSpecialty: "Medicinsk speciale",
    selectSpecialty: "Vælg speciale",
    specialtyDescription: "Vi opretter skabeloner specifikt til dit speciale",
    professionalRegistrationNumber: "Autorisationsnummer (valgfrit)",
    professionalRegistrationPlaceholder: "Autorisationsnummer eller andet registreringsnummer",
    professionalRegistrationDescription: "Dit autorisationsnummer eller registreringsnummer fra et fagligt organ",
    welcomeTitle: "Velkommen til Patient Watch!",
    welcomePatientDescription: "Hjælp med at forbedre behandling og forskning ved at spore din genoptræning!",
    welcomeClinicianDescription:
        "Giv patienter personlig pleje, spar tid til aftaler og få værdifuld indsigt i dine behandlinger.",
    welcomeSecretaryDescription: "Administrer patientjournaler og koordiner pleje effektivt på tværs af dit team.",
    welcomeManagerDescription: "Følg, hvordan data indsamles på tværs af din organisation.",
    settingUpAccount: "Opretter din konto...",
    gettingAccountReady: "Vi gør alt klar til dig",
    continueToProfileSetup: "Fortsæt til profilopsætning",
    processingNewUser: "Behandler ny bruger",
    onboardingComplete: "Oprettelse afsluttet",
    authenticationError: "Godkendelsesfejl",
    setupMoment: "Et øjeblik, vi opsætter alt...",
    settingUpDiary: "Opsætter din dagbog...",
    almostThere: "Næsten færdig!",
    patientSetupCompleteDescription:
        "Tak for at have gennemført opsætningen. Tilføj dine dagbogsindtastninger løbende, så kan du se dine scorer på fremskridtsgrafen.",
    setupCompleteDescription: "Du kan nu bruge Patient Watch til at dele dine fremskridt!",
    supportMessage: "Send venligst en besked til support@patient-watch.com",
    retry: actionCopyDa.retry,
    edit: actionCopyDa.edit,
    current: "Nuværende",
    change: "Skift",
    deleteAccount: "Slet konto",
    deleteAccountConfirmTitle: "Er du helt sikker?",
    deleteAccountConfirmDescription:
        'Denne handling kan ikke fortrydes. For at bekræfte, at du vil slette din konto, skal du skrive "delete my account" nedenfor.',
    deleteAccountPageDescription: "Slet permanent din konto og alle tilknyttede data",
    deleteAccountReason: "Årsag til sletning af konto",
    deleteAccountSubmit: "Slet konto",
    submitting: actionCopyDa.submitting,
    deleteAccountConfirmationLabel: "Bekræftelse",
    deleteAccountPlaceholder: 'Skriv "delete my account"',
    deletingAccount: "Sletter...",
    warningNotificationsDisabled: "Advarsel: Notifikationer deaktiveret",
    editPreferences: "Rediger indstillinger",
    remindersDescription: "Påmindelser er afgørende for, hvordan Patient Watch forbedrer dit helbred.",
    receiveEmailReminders: "Modtag e-mailpåmindelser.",
    receiveSmsReminders: "Modtag SMS-påmindelser.",
    pushNotificationSettingsError:
        "For at aktivere push-notifikationer skal du aktivere notifikationer i dine app-indstillinger.",
    actionRequired: (count: number) => `Handling påkrævet (${count})`,
    actionRequiredForms: (count: number) => `Handling påkrævet (${count} ${count === 1 ? "formular" : "formularer"})`,
    diaryCardDescription:
        "Dagbøger er dine personlige sundhedslogbøger, der hjælper med at forbedre behandling og forskning.",
    formDue: (count: number) => `Du har ${count} ${count === 1 ? "formular" : "formularer"}, der skal udfyldes.`,
    diariesNeedAttention: (count: number) =>
        `Du har ${count} ${count === 1 ? "dagbog" : "dagbøger"} med formularer, der kræver din opmærksomhed.`,
    welcomeModalTitle: (name: string) => `Velkommen, ${name}!`,
    welcomeDescription: "Din konto er klar, og dine specialskabeloner er klar til brug.",
    welcomeTestPatientTitle: "Prøv det med en testpatient",
    welcomeTestPatientDescription:
        "For at se, hvordan dine patienter oplever Patient Watch, kan du invitere en testbruger med en anden e-mailadresse.",
    welcomeAddFirstPatient: "Tilføj min første patient",
    welcomeDoctorFallback: "Læge",
    closeBanner: "Luk banner",
    home: "Hjem",
    currentPlan: "Nuværende abonnement",
    currentPlanDescription: "Dit abonnement og din dagbogskvote",
    noActiveSubscription: "Du har ikke et aktivt abonnement",
    billingStatus: "Status",
    nextBillingDate: "Næste faktureringsdato",
    accessUntil: "Adgang indtil",
    planDetails: "Abonnementsdetaljer",
    trialPlanDetails: "5 nye dagbøger pr. faktureringsperiode",
    enterprisePlanDetails: "Ubegrænsede dagbøger",
    choosePlanToStart: "Vælg et abonnement for at komme i gang med Patient Watch",
    upgradeYourPlan: "Opgrader dit abonnement",
    changeYourPlan: "Skift abonnement",
    availablePlans: "Tilgængelige abonnementer",
    upgradePlanDescription: "Skift fra Free til Starter eller Pro for en højere dagbogskvote",
    changePlanDescription: "Sammenlign abonnementer og skift dit abonnement",
    choosePlanDescription: "Vælg det abonnement, der passer bedst til dine behov",
    preferStartFree: "Vil du starte gratis?",
    createFreeAccount: "Opret en gratis konto",
    needMore: "Brug for mere? Se vores",
    enterprisePlan: "Enterprise-abonnement",
    cancelSubscription: "Opsig abonnement",
    managePaymentMethod: "Administrer betalingsmetode",
    undoCancellationHint:
        "Vil du beholde dit abonnement? Brug Administrer betalingsmetode til at åbne Stripe og fortryde opsigelsen.",
    paymentRequired: "Betaling påkrævet",
    paymentOverdue:
        "Din betaling er forfalden. Opdater venligst din betalingsmetode for at fortsætte med at bruge Patient Watch.",
    subscriptionCanceling: "Abonnement opsiges",
    subscriptionCancelingOn: (date: string) => `Dit abonnement opsiges den ${date}. Du beholder adgangen indtil da.`,
    subscriptionCancelingPeriod:
        "Dit abonnement opsiges ved udgangen af faktureringsperioden. Du beholder adgangen indtil da.",
    subscriptionCancelled: "Abonnement opsagt",
    subscriptionCancelledDescription:
        "Dit betalte abonnement er afsluttet. Vælg et abonnement nedenfor for at genstarte faktureringen.",
    unableToCancel: "Kunne ikke opsige",
    unableToChangePlan: "Kunne ikke skifte abonnement",
    unableToOpenBillingPortal: "Kunne ikke åbne faktureringsportalen",
    unableToStartCheckout: "Kunne ikke starte checkout",
    failedToLoadBilling: "Kunne ikke indlæse faktureringsoplysninger. Prøv igen senere.",
    billingStatusCanceling: "OPSIGES",
    billingStatusUnknown: "UKENDT",
    pleaseTryAgain: "Prøv venligst igen.",
    planStarter: "Starter",
    planPro: "Pro",
    perMonth: "/måned",
    currentPlanBadge: "Nuværende",
    popularBadge: "Populær",
    starterDiaries: "20 nye dagbøger/måned",
    proDiaries: "50 nye dagbøger/måned",
    emailSmsReminders: "E-mail- og SMS-påmindelser",
    emailSupport: "E-mail-support",
    prioritySupport: "Prioriteret support",
    currentPlanButton: "Nuværende abonnement",
    subscribeToStarter: "Abonner på Starter",
    subscribeToPro: "Abonner på Pro",
    downgradeToStarter: "Nedgrader til Starter",
    upgradeToPro: "Opgrader til Pro",
    includedInEnterprise: "Inkluderet i Enterprise",
};
